import {useGetData} from '../../src/apiservice/apiCall'


export function useTradeFair(){
	return useGetData('/api/WebApi/GetTradeFair')
}
